import { useContext } from "react";
import { GetRuleContext, SetRuleContext } from '../context/rule/RulesContext';

export function useGetRule() {
  return useContext(GetRuleContext);
}

export function useSetRule() {
  return useContext(SetRuleContext);
}